<template>
    <div v-loading="loading" style="height:100vh">

    </div>
</template>
<script>
import {getUrlKey} from '../../static/js/util'
export default{
    data(){
        return{
            loading:false,
        }
    },
    created(){
        var res = this.getUrlKey()
        console.log('当前请求url request key:',res);
        this.startActivity(res)
    },
    methods:{
        getUrlKey,
        startActivity(obj){
            var token = decodeURIComponent(obj.token)
            var tokenType = decodeURIComponent(obj.tokenType)
            this.loading = true
            this.$axios.post(this.$URL.loginToken,{token:token,tokenType:tokenType}).then(res=>{
                this.loading = false
                if(res&&!res.error){
                     this.errorMsg = ""; //登陆成功把页面上错误信息清除
                    localStorage.setItem("token", res.token);
                    localStorage.setItem("email", res.email);
                    localStorage.setItem("tokenType",res.tokenType)
                    this.$store.commit("saveService", {});
                    this.$store.commit("savePositionInfo", {});
                    this.$router.push("/applicantHome");
                }else{
                    this.$router.push({path:'/login'})
                }
            }).catch(err=>{
                this.loading = false
                this.$router.push({path:'/login'})
            })
        }

    }
}
</script>